function _define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _define_property(target, key, source[key]);
        });
    }
    return target;
}
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useRef, useState } from "react";
import classnames from "classnames";
import YoutubeVideoComponent from "components/core/youtube-video/youtube-video-component";
import PictureComponent from "/components/core/picture/picture-component";
import { StyledYoutubeVideoWithPosterComponent } from "./youtube-video-with-poster-component.scss";
import { buttonThemes } from "./constants";
import { withGenericConfig } from "/contexts/generic-config-context";
import DefaultProps from "./default-props";
const YOUTUBE_ASPECT_RATIO = 9 / 16;
const YoutubeVideoWithPosterComponent = (props)=>{
    const [isPosterVisible, setIsPosterVisible] = useState(true);
    const [playVideo, setPlayVideo] = useState(false);
    const ref = useRef(null);
    const { width, fitToParent, playButtonColor, poster, previewRenderer, alt, playButtonSize, translate, showShadow, videoId, muted, volume, videoOpts } = props;
    const onPlayButtonClicked = (e)=>{
        setIsPosterVisible(false);
        setPlayVideo(true);
    };
    const getInlineStyle = ()=>{
        var _ref_current;
        const styleWidth = (_ref_current = ref.current) === null || _ref_current === void 0 ? void 0 : _ref_current.offsetWidth;
        if (fitToParent && styleWidth) {
            return {
                width: styleWidth,
                height: styleWidth * YOUTUBE_ASPECT_RATIO
            };
        }
        return {
            height: "auto",
            width
        };
    };
    const getButtonContainerStyle = ()=>{
        var _buttonThemes_playButtonColor;
        if (!playButtonColor) return {};
        return {
            backgroundColor: (_buttonThemes_playButtonColor = buttonThemes[playButtonColor]) === null || _buttonThemes_playButtonColor === void 0 ? void 0 : _buttonThemes_playButtonColor.color
        };
    };
    const getButtonArrowStyle = ()=>{
        var _buttonThemes_playButtonColor;
        if (!playButtonColor) return {};
        return {
            borderLeftColor: (_buttonThemes_playButtonColor = buttonThemes[playButtonColor]) === null || _buttonThemes_playButtonColor === void 0 ? void 0 : _buttonThemes_playButtonColor.background
        };
    };
    const renderPreview = ()=>{
        if (previewRenderer) {
            return isPosterVisible && previewRenderer();
        }
        return /*#__PURE__*/ _jsxs("div", {
            className: classnames("poster-image-wrapper", {
                "with-shadow": showShadow
            }),
            style: {
                display: isPosterVisible ? "block" : "none"
            },
            children: [
                /*#__PURE__*/ _jsx("button", {
                    className: classnames("play-button-container", playButtonSize),
                    style: getButtonContainerStyle(),
                    "aria-label": translate("accessibility.button.playVideo"),
                    children: /*#__PURE__*/ _jsx("div", {
                        className: "play-button",
                        style: getButtonArrowStyle()
                    })
                }),
                /*#__PURE__*/ _jsx(PictureComponent, {
                    pictureClass: "poster-image",
                    alt: alt,
                    src: poster,
                    screenRatios: {
                        mobile: 0.99,
                        mobileRetina: 0.99
                    }
                })
            ]
        });
    };
    return /*#__PURE__*/ _jsxs(StyledYoutubeVideoWithPosterComponent, {
        className: classnames("youtube-video-with-poster-component", {
            "hide-poster": !isPosterVisible
        }),
        onClick: onPlayButtonClicked,
        ref: ref,
        children: [
            /*#__PURE__*/ _jsx("div", {
                className: "video-component-wrapper",
                style: {
                    display: isPosterVisible ? "none" : "block"
                },
                children: /*#__PURE__*/ _jsx(YoutubeVideoComponent, {
                    videoId: videoId,
                    playing: playVideo,
                    muted: muted,
                    volume: volume,
                    opts: _object_spread({}, getInlineStyle(), videoOpts),
                    showShadow: showShadow
                })
            }),
            renderPreview()
        ]
    });
};
export default withGenericConfig(YoutubeVideoWithPosterComponent);
YoutubeVideoWithPosterComponent.defaultProps = DefaultProps;
